<template>
  <section class="section --about --large">
    <TitleBlock :content="content.titleBlock" class="--center --bottom" />
    <div class="relative">
      <Button :route="content.route" :label="content.hotel_label.toString()" class="--hotel" />
      <Image :source="content.image" />
      <RightAddressLink :content="content.contact" class="--end" />
    </div>
  </section>
</template>

<script>
import TitleBlock from '@/components/blocks/TitleBlock.vue'
import Image from '@/components/global/Image.vue'
import Button from '@/components/small/Button.vue'
import RightAddressLink from '@/components/small/RightAddressLink.vue'

export default {
  name: 'AboutSection',
  components: { Button, Image, RightAddressLink, TitleBlock },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
